import { t } from '@sportninja/common/i18n'

/**
 * `t` is loosely typed in `common/i18n` and every call site here needs a string
 * back. One cast beats one per render.
 */
const translate = t as (
  key: string,
  options?: Record<string, unknown>
) => string

/**
 * Copy lives under `common:`. `gameLoadingMore` / `gameNoMoreResults` are
 * reused as-is — their text is already generic ("Loading More...", "No More
 * Results") and only the key name is historical, from the game list this was
 * extracted from. The error copy is NOT reused: `gameLoadFailed` reads "Some
 * games could not be loaded", so `listLoadFailed` / `listLoadRetry` were added
 * alongside it for lists that hold anything else.
 */
export const sharedLabel = (
  key: string,
  params?: Record<string, unknown>
): string => translate(`common:${key}`, params)
